// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".motoboy-presence-list__item[data-v-2562a40a] {\n  gap: 0.5rem;\n}[dir] .motoboy-presence-list__item[data-v-2562a40a] {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #ebe9f1;\n}\n[dir] .motoboy-presence-list__item[data-v-2562a40a]:last-child {\n  border-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
